module.exports = __webpack_public_path__ + "img/cup-straw-swoosh.6ec87c3b.svg";